var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCincinnatiBengalsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    height: 266,
    viewBox: "0 0 378.82007 266.45081",
    width: 379,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25 0 0 -1.25 -190 625)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m424 397c-1.6 0.812-1.4 2.26-0.248 3.12 13.6 10.1 22.9 23.1 22.9 43.1 0 23.7-17 57-83.3 57h-171l-38.7-67.5h28.4c3.18 0 5.74-2.56 5.74-5.73v-67.3c0-3.17-2.56-5.73-5.74-5.73h-30.5l39.1-67.2 181 0.0211c58.3 0 83.5 30.4 83.5 63.1 0 21.6-15.4 39.2-31 47.1",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m323 408h-28.1v27c0.0264 2.83 2.32 5.12 5.16 5.12h22.9c13.5 0 18.4-6.86 18.4-15.8 0-9.5-5-16.3-18.4-16.3zm0-62.2h-22.9c-2.85 0-5.16 2.31-5.16 5.15v27h28.1c13.5 0 18.4-6.59 18.4-15.8 0-9.48-5-16.3-18.4-16.3zm80.2 49.2c-2.06 0.485-1.72 3.01-0.216 3.57 18.5 7.02 29.4 19.5 29.4 41.5 0.258 29.5-25.8 49.8-68.2 49.8h-161l-28.2-49.8h19.4c3.84 0 6.94-3.1 6.94-6.94v-80.4c0-3.84-3.1-6.94-6.94-6.94h-19.2l28.4-49.6 168 0.0211c48 0 67.7 31.9 67.7 55.3 0 20.6-15.2 38.4-36.3 43.5",
    fill: "#fb4f14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m258 310c-29.8 56-37.6 120-26.5 180h-28.2l-28.2-49.8h19.4c3.84 0 6.94-3.1 6.94-6.94v-61.7c14.5-23.5 35.4-46 56.5-61.2zm141 174c-34.1-50.6-52.6-115-44.3-174 10.2 49.4 36.7 95 78 128 0.0105 0.491 0.0527 0.966 0.0527 1.47 0.174 20.3-12.2 36.3-33.7 44.3zm-57.2 5.54c-5.35-14-11-30.9-15.7-49.9-0.844 0.0634-1.74 0.1-2.66 0.1h-22.9c-2.84 0-5.13-2.28-5.16-5.12v-27h24.1c-1.59-9.69-2.88-19.7-3.74-30h-20.4v-27c0-2.85 2.31-5.15 5.16-5.15h14.1c0.211-16.2 1.65-32.8 4.68-49.5h-21c-16.5 39.9-39.3 107-16.7 194h60.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCincinnatiBengalsLogo);
export default __webpack_public_path__ + "static/media/cincinnati-bengals-logo.e58611f65e9923936ed50b2a0ed96ddb.svg";
export { ForwardRef as ReactComponent };